import { getAuth } from 'firebase/auth';
import { BudgetCategory } from '../pages/plan/budget/types.js';
import WedifyApiRequest from './wedify_api_request.js';

// When the totalBudget is updated, each subsection has to be updated based on its percentage
export const updateTotalBudget = async (budget: number) => {
    const auth = getAuth();
    const currentUser = auth.currentUser;
    if (!currentUser) {
        console.log("User needs to log in before planning");
        return;
    }
  
    try {
        const wedifyApiRequest = new WedifyApiRequest();
        const response = await wedifyApiRequest.makeRequest(`${process.env.REACT_APP_API_BASE_URL}/api/v1/budget-sections`, "GET");

        if (response && response.ok) {
            const budgetData = await response.json()
            const newBudgetData = budgetData.map(element => ({
                id: element.id,
                name: element.name,
                cost: element.percentage * (budget / 100.0) // Calculate cost based on percentage and budget
            }));
            const updateResponse = await wedifyApiRequest.makeRequest(`${process.env.REACT_APP_API_BASE_URL}/api/v1/budget-sections/bulk`, "PUT", JSON.stringify(newBudgetData) as any);
            console.log("Budget updated successfully:", updateResponse);
        }
    } catch (error) {
        console.error('Error fetching budget data:', error);
        throw error;
    }
};

export const updateBudgetSections = async (budget: BudgetCategory[]) => {   
    const newBudgetData = budget.map(item => ({
        id: item.id, // Assuming BudgetCategory has an id property
        name: item.name, // Assuming BudgetCategory has a name property
        percentage: item.percentage, // Assuming BudgetCategory has a percentage property
        cost: item.amount
    }));

    try {
        const wedifyApiRequest = new WedifyApiRequest();
        const updateResponse = await wedifyApiRequest.makeRequest(`${process.env.REACT_APP_API_BASE_URL}/api/v1/budget-sections/bulk`, "PUT", JSON.stringify(newBudgetData) as any);

        if (updateResponse && updateResponse.ok) {
            return await updateResponse.json()
        } else {
            console.log("Updating budget sections failed");
            return null;
        }
    } catch (error) {
        console.error('Error updating budget sections:', error);
        throw error; // Rethrow the error for further handling if needed
    }
};

export const getBudget = async () => {
    try {
        const wedifyApiRequest = new WedifyApiRequest();
        const response = await wedifyApiRequest.makeRequest(`${process.env.REACT_APP_API_BASE_URL}/api/v1/budget-sections`, "GET");
        if (response && response.ok) {
            return await response.json()
        } else {
            console.log("No budget data found in the response.");
            return null;
        }
    } catch (error) {
        console.error('Error fetching budget data:', error);
        throw error;
    }
};

